"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FullBleed = void 0;
const react_1 = require("react");
const ScrollableParent_1 = require("./ScrollableParent");
const Css_1 = require("../../Css");
/** Provides a way to extend the full width of the ScrollableParent */
function FullBleed({ children, omitPadding = false }) {
    const { pr, pl } = (0, ScrollableParent_1.useScrollableParent)();
    return !pr && !pl
        ? children
        : (0, react_1.cloneElement)(children, {
            style: Css_1.Css.ml(`-${pl}`).mr(`-${pr}`).if(!omitPadding).pl(pl).pr(pr).$,
        });
}
exports.FullBleed = FullBleed;
